module.exports = __webpack_public_path__ + "img/new1.f900b47d.png";